export const state = {
  user: {
    id: 'abc123',
    name: 'Adam'  // I removed the last name Jahr here our title is on one line
  }
}